// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Cancellation24Hours20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Cancellation24Hours20: FC<Cancellation24Hours20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="21"
        >
            <path d="M12.502 4.75a.97.97 0 0 1-.71-.29.959.959 0 0 1-.292-.708c0-.279.097-.516.29-.71a.96.96 0 0 1 .708-.292.97.97 0 0 1 .71.29.959.959 0 0 1 .292.708c0 .279-.097.516-.29.71a.96.96 0 0 1-.708.292Zm0 13.5a.97.97 0 0 1-.71-.29.959.959 0 0 1-.292-.708.97.97 0 0 1 .29-.71.959.959 0 0 1 .708-.292.97.97 0 0 1 .71.29.959.959 0 0 1 .292.708.97.97 0 0 1-.29.71.959.959 0 0 1-.708.292Zm3.5-10.5a.97.97 0 0 1-.71-.29.959.959 0 0 1-.292-.708c0-.279.097-.516.29-.71a.96.96 0 0 1 .708-.292.97.97 0 0 1 .71.29.959.959 0 0 1 .292.708c0 .279-.096.516-.29.71a.96.96 0 0 1-.708.292Zm0 7.5a.97.97 0 0 1-.71-.29.959.959 0 0 1-.292-.708.97.97 0 0 1 .29-.71.959.959 0 0 1 .708-.292.97.97 0 0 1 .71.29.959.959 0 0 1 .292.708.97.97 0 0 1-.29.71.959.959 0 0 1-.708.292Zm1-3.75a.97.97 0 0 1-.71-.29.959.959 0 0 1-.292-.708c0-.279.096-.516.29-.71a.96.96 0 0 1 .708-.292.97.97 0 0 1 .71.29.959.959 0 0 1 .292.708.97.97 0 0 1-.29.71.959.959 0 0 1-.708.292ZM10 18.5a7.787 7.787 0 0 1-3.108-.625 8.076 8.076 0 0 1-2.548-1.719 8.065 8.065 0 0 1-1.719-2.551A7.819 7.819 0 0 1 2 10.49c0-1.104.208-2.14.625-3.105a8.076 8.076 0 0 1 4.267-4.26A7.788 7.788 0 0 1 10 2.5V4c-1.806 0-3.34.632-4.604 1.896C4.132 7.16 3.5 8.694 3.5 10.5s.632 3.34 1.896 4.604C6.66 16.368 8.194 17 10 17v1.5Zm2.792-4.458L9.25 10.5v-5h1.5v4.375l3.104 3.104-1.062 1.063Z" />
        </svg>
    );
};

export default Cancellation24Hours20;
